import { Navigate, Outlet, useLocation } from "react-router-dom";
import toast from "react-hot-toast";

export default function PrivateRoute({ children }) {
  const location = useLocation();

  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
  const loginTimestamp = localStorage.getItem("loginTimestamp");
  const dealerStr = localStorage.getItem("dealer");

  if (!dealerStr) {
    return <Navigate to="/" replace />;
  }

  const dealer = JSON.parse(dealerStr);
  const userType = dealer?.type || "dealer";

  const SESSION_DURATION_MS = 12 * 60 * 60 * 1000; // 12 hours

  // Session expired
  if (
    isLoggedIn &&
    loginTimestamp &&
    Date.now() - Number(loginTimestamp) > SESSION_DURATION_MS
  ) {
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("dealer");
    localStorage.removeItem("userType");
    localStorage.removeItem("loginTimestamp");
    toast.error("Session expired. Please log in again.");
    return <Navigate to="/" replace />;
  }

  // Not logged in
  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  const currentPath = location.pathname;

  // Non-admin trying to access admin area
  if (currentPath.startsWith("/admin-") && userType !== "admin") {
    return <Navigate to="/home" replace />;
  }

  // Admin trying to access dealer-only area (optional strictness)
  // You can uncomment if you want to block admin from /home
  // if (currentPath.startsWith("/home") && userType === "admin") {
  //   return <Navigate to="/admin-dashboard" replace />;
  // }

  return children ? children : <Outlet />;
}